// Config nasazení (varianty A/B/C) — přichází z GET /api/auth/capabilities (pole `deploy`),
// nikdy se nečte z .env/build-time. Server je jediný zdroj pravdy — viz
// doc/plans/deploy-variants-a-b-c.md a cw-server/doc/plans/deploy-variants-cw-server-handoff.md.
// Výchozí hodnoty odpovídají tomu, co server vrací jako fallback, když deploy-config.json
// na instanci chybí (= chování varianty A) — než odpověď dorazí, appka běží na nich.
import { create } from 'zustand'

export const useDeployConfigStore = create((set) => ({
  loaded: false,
  variant: 'A',
  dataSources: { readEnabled: ['open', 'oracle'], onlineFetchEnabled: ['open', 'oracle'] },
  menuIcons: ['station-simple', 'station-group'],
  registrationEnabled: true,
  loginRolesAllowed: ['user', 'admin'],
  footerNote: '',

  // cfg = pole `deploy` z GET /api/auth/capabilities (viz buildCapabilities na serveru).
  setConfig: (cfg) => set({ ...cfg, loaded: true }),
}))
